"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7871],{

/***/ 27871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 2l1.3.3C19.1 3 21 5.4 21 8.2V15c0 .6-.4 1-1 1h-4v5c0 .6-.4 1-1 1s-1-.4-1-1V3c0-.3.1-.6.3-.8.3-.2.6-.3.9-.2zm.8 12h3V8.2c0-1.9-1.2-3.4-3-3.9V14zM9 3c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1H8v9c0 .6-.4 1-1 1s-1-.4-1-1v-9H4c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1s1 .4 1 1v7h1V3c0-.6.4-1 1-1s1 .4 1 1v7h1V3z"
}), "Restaurant"));


/***/ })

}]);